import React, {  Component } from 'react';


export default class ReturnPolicyGuidelinesOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });

		this.props.handleDialog && this.props.handleDialog('ReturnPolicyGuidelinesOverlayDialog', false);

    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="returnPolicyGuidelinesOverlayDialog">
                <div className="blackoutLayer" />
                <div className="overlayDialogWindow d-none d-sm-block" style={{minWidth: "800px"}}>
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Return Policy Guidelines</h2>
                    <ul>
                        <li style={{marginBottom: 20}}>If you are a Retail Distributor or and/or Authorized Builder Distributor, your return request must be approved by your Area Sales Manager</li>
                        <li style={{marginBottom: 20}}>For product delivered by a GEA SDS, any discrepancies should be reported to the delivery agent and noted as an exception when signing for the order.</li>
                        <li style={{marginBottom: 20}}>No returns over 90 days</li>
                        <li style={{marginBottom: 20}}>
                            Restocking Fees:
                            <table className="dataTable customBorderTable">
                                <thead>
                                    <tr>
                                        <th rowSpan={ 2 } className="valign-middle border-bottom-3px txt-ctr">Reason for Return</th>
                                        <th rowSpan={ 2 } className="border-bottom-3px txt-ctr">Condition of Product</th>
                                        <th colSpan={ 2 } className="txt-ctr border-bottom-1px">Age from Invoice</th>
                                    </tr>
                                    <tr className="background-eee">
                                        <th className="txt-ctr">0-90 days</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="no-bg">
                                        <td className="valign-middle" rowSpan={ 2 }>GE Appliances Order Error,Shipping Error, Damage or Defective</td>
                                        <td>Crated</td>
                                        <td>None</td>
                                    </tr>
                                    <tr className="no-bg">
                                        <td className="no-border-left">Uncrated</td>
                                        <td>None</td>
                                    </tr>
                                    <tr className="no-bg">
                                        <td className="valign-middle" rowSpan={ 2 }>Customer Errors, Changes or Damage</td>
                                        <td>Crated</td>
                                        <td>10% of invoice + Freight</td>
                                    </tr>
                                    <tr className="no-bg">
                                        <td>Uncrated</td>
                                        <td>15% of invoice + Freight</td>
                                    </tr>
                                </tbody>
                            </table>
                        </li>
                    </ul>
                </div>
                <div className="overlayDialogWindow d-block d-sm-none" style={{minWidth: "250px"}}>
                    <a className="closeButton border-0 p-2" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title p-2">Return Policy Guidelines</h2>
                    <ul>
                        <li style={{marginBottom: 20}}>If you are a Retail Distributor or and/or Authorized Builder Distributor, your return request must be approved by your Area Sales Manager</li>
                        <li style={{marginBottom: 20}}>For product delivered by a GEA SDS, any discrepancies should be reported to the delivery agent and noted as an exception when signing for the order.</li>
                        <li style={{marginBottom: 20}}>No returns over 90 days</li>
                        <li style={{marginBottom: 20}}>
                            Restocking Fees:
                            <table>
                                <thead className="border-1 text-center">
                                    <tr className='background-eee'>
                                        <th className="p-3" colSpan={2}>Reason for Return</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="border-1 text-center">
                                        <td className="p-3" colSpan={2}>GE Appliances Order Error,Shipping Error, Damage or Defective</td>
                                    </tr>
                                    <tr className="background-eee text-center">
                                        <td className="p-3 border-1 fw-bold">Condition of Product</td>
                                        <td className="p-3 border-1 fw-bold">Age from Invoice 0-90 days</td>
                                    </tr>
                                    <tr className="text-center">
                                        <td className="p-3 border-1">Crated</td>
                                        <td className="p-3 border-1">None</td>
                                    </tr>
                                    <tr className="text-center">
                                        <td className="p-3 border-1">Uncrated</td>
                                        <td className="p-3 border-1">None</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table>
                                <thead className="border-1 text-center">
                                    <tr className='background-eee' >
                                        <th className="p-3" colSpan={2}>Reason for Return</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="border-1 text-center">
                                        <td className="p-3"colSpan={2}>Customer Errors, Changes or Damage</td>
                                    </tr>
                                    <tr className="background-eee text-center">
                                        <td className="p-3 border-1 fw-bold">Condition of Product</td>
                                        <td className="p-3 border-1 fw-bold">Age from Invoice 0-90 days</td>
                                    </tr>
                                    <tr className="text-center">
                                        <td className="p-3 border-1">Crated</td>
                                        <td className="p-3 border-1">10% of invoice + Freight</td>
                                    </tr>
                                    <tr className="text-center">
                                        <td className="p-3 border-1">Uncrated</td>
                                        <td className="p-3 border-1">15% of invoice + Freight</td>
                                    </tr>
                                </tbody>
                            </table>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/returnPolicyGuidelinesOverlayDialog.js